/** localStorage keys for staff admin session (keep in sync with axios client + auth store). */
export const AUTH_ACCESS_KEY = 'tb_admin_access_token'
export const AUTH_REFRESH_KEY = 'tb_admin_refresh_token'
export const AUTH_USER_KEY = 'tb_admin_user'
export const AUTH_OWNER_IMPERSONATION_KEY = 'tb_admin_owner_impersonation'
export const AUTH_VENDOR_IMPERSONATION_OWNER_SESSION_KEY = 'tb_admin_vendor_impersonation_owner_session'
export const AUTH_TRUSTED_DEVICE_KEY = 'tb_admin_trusted_device'
